import React from "react";

/**
 * Renders text where *segments wrapped in single asterisks* become italic accents.
 * Example: "Welcome to *Heritage Dahlias.*" → "Welcome to " + <i>Heritage Dahlias.</i>
 *
 * Props:
 *   text: string
 *   italicClass: tailwind class to apply to italic chunks (default Playfair italic with clay accent)
 *   as: HTML tag name (default "span")
 */
export default function CmsText({ text = "", italicClass = "font-display-italic text-[var(--dahlias-clay)]", as: Tag = "span", ...rest }) {
  if (!text) return null;
  // split keeping markers
  const parts = String(text).split(/(\*[^*]+\*)/g);
  return (
    <Tag {...rest}>
      {parts.map((p, i) => {
        if (/^\*[^*]+\*$/.test(p)) {
          return (
            <em key={i} className={italicClass} style={{ fontStyle: "normal" }}>
              {p.slice(1, -1)}
            </em>
          );
        }
        return <React.Fragment key={i}>{p}</React.Fragment>;
      })}
    </Tag>
  );
}
